module.exports = __webpack_public_path__ + "static/media/equality-and-diversity.c83aa781.jpg";